/**
 * PATH: packages/ui/src/kanban/components/peekQueryKeys.ts
 * FILE_ID: UI-KANBAN-PEEK-QUERY-KEYS-001
 * PURPOSE: Shared react-query keys for the card thread peek (AI thread +
 *   comments) so the handle's hover-prefetch, the peek's read, and the drawer's
 *   comment feed all hit the SAME cache entry.
 * WHY:
 *   FEAT-2026-06-21-KANBAN-CARD-PEEK-RICHEN — the peek preloads on hover and
 *   the drawer already reads comments under `['kanban','card',id,'comments']`.
 *   Centralising the keys keeps the prefetch ↔ read ↔ drawer caches in lock-step
 *   (and keeps KanbanCardPeek a pure component file for fast-refresh).
 * RELATED:
 *   - ./KanbanCardPeek, ./KanbanCardPeekHandle, ./KanbanCardPeekComments
 *   - ./card-detail/CommentsSection.tsx (same comments key)
 */

/** AI thread summary for a card — preloaded on card hover, read by the peek. */
export function aiThreadQueryKey(cardId: string): readonly unknown[] {
  return ['kanban', 'card', cardId, 'ai-thread']
}

/** Human comments feed for a card. MUST match the drawer's CommentsSection key
 *  so the peek + drawer share one cache entry. */
export function cardCommentsQueryKey(cardId: string): readonly unknown[] {
  return ['kanban', 'card', cardId, 'comments']
}
